import http from '../core/http-common'
import { ITransactionResponse, IRemoteOfficeType } from '../types/MainType'

class HomeOfficeService {
  createHomePlan(request: any) {
    return http.post<ITransactionResponse>('/HomeOffice/SaveHomeOfficeReservation', request)
  }

  deleteHomePlan(request: any) {
    return http.post<ITransactionResponse>('/HomeOffice/DeleteHomeOfficeReservation', request)
  }

  getRemoteOfficeTypeList() {
    return http.get<IRemoteOfficeType[]>('/RemoteOfficeType/GetRemoteOfficeTypeList')
  }
}

export default new HomeOfficeService()
